export default "__VITE_ASSET__l9dLp7yh__";